import React from 'react';
import {
  RadioButton,
  RadioButtonGroup,
  SelectField,
  MenuItem,
} from 'material-ui';
import { isEqual } from 'lodash';

import { filterChosenItems, filterByCluster, filterByTime } from './utils';
import { VenueField, ChipRenderer } from './components';
import DatePicker from '../inputs/DatePicker';

class VenueComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      area: '',
      radioChoice: 'allVenues',
      venues: this.props.venues,
      date: new Date(),
    };
  }

  componentWillReceiveProps = (nextProps) => { // eslint-disable-line consistent-return
    if (!isEqual(this.props.market, nextProps.market)) {
      if (this.state.radioChoice === 'allVenues') {
        return this.setState({ venues: nextProps.venuesByMarket }, () => this.props.handleVenuesChange(this.state.venues));
      }
      if (this.state.radioChoice === 'venues') {
        return this.setState({ venues: [] }, () => this.props.handleVenuesChange(this.state.venues));
      }
      if (this.state.radioChoice === 'area') {
        return this.setState({ venues: nextProps.venues }, () => this.props.handleVenuesChange(this.state.venues));
      }
      if (this.state.radioChoice === 'cluster') {
        return this.setState({ venues: filterByCluster(nextProps.venuesByMarket, this.state.cluster) }, () => this.props.handleVenuesChange(this.state.venues));
      }
      if (this.state.radioChoice === 'sameStoreSales') {
        return this.setState({ venues: filterByTime(nextProps.venuesByMarket, this.state.date) }, () => this.props.handleVenuesChange(this.state.venues));
      }
    }
    if (!isEqual(this.props.venues, nextProps.venues)) {
      if (this.state.radioChoice === 'allVenues') {
        return this.setState({ venues: nextProps.venuesByMarket }, () => this.props.handleVenuesChange(this.state.venues));
      }
      if (this.state.radioChoice === 'venues') {
        return this.setState({ venues: nextProps.venues }, () => this.props.handleVenuesChange(this.state.venues));
      }
    }
    if (!isEqual(this.props.venuesByMarket, nextProps.venuesByMarket)) {
      if (this.state.radioChoice === 'allVenues') {
        return this.setState({ venues: nextProps.venuesByMarket }, () => this.props.handleVenuesChange(this.state.venues));
      }
    }
  }

  handleRadioChange = (event, value) => {
    if (value === 'allVenues') {
      return this.setState({ radioChoice: value, venues: this.props.venuesByMarket }, () => this.props.handleVenuesChange(this.state.venues));
    }
    if (value === 'venues') {
      return this.setState({ radioChoice: value, venues: [] }, () => this.props.handleVenuesChange(this.state.venues));
    }
    if (value === 'area') {
      return this.setState({ radioChoice: value, venues: [] }, () => this.props.handleVenuesChange(this.state.venues));
    }
    if (value === 'cluster') {
      return this.setState({ radioChoice: value, venues: [] }, () => this.props.handleVenuesChange(this.state.venues));
    }
    if (value === 'sameStoreSales') {
      return this.setState({ radioChoice: value, venues: filterByTime(this.props.venuesByMarket, this.state.date) }, () => this.props.handleVenuesChange(this.state.venues));
    }
    return this.setState({ radioChoice: value });
  }

  handleSearch = (searchText) => {
    this.setState({ searchVenues: searchText });
  }

  handleSelectVenue = (venue) => {
    const { venues } = this.state;
    venues.push(venue);
    this.setState({ venues, searchVenues: '' }, () => this.props.handleVenuesChange(this.state.venues));
  }

  handleAreaChange = (event, key, value) => {
    const { venuesByMarket } = this.props;
    // const filteredVenues = filterByAreaManager(venuesByMarket, value, this.props.areaManagers);
    const filteredVenues = venuesByMarket.filter((venue) => venue.area === value);
    this.setState({ area: value, venues: filteredVenues }, () => this.props.handleVenuesChange(this.state.venues));
  }

  handleClusterChange = (event, key, value) => {
    const { venuesByMarket } = this.props;
    const filteredByCluster = filterByCluster(venuesByMarket, value);
    this.setState({ cluster: value, venues: filteredByCluster }, () => this.props.handleVenuesChange(filteredByCluster));
  }

  handleRemoveChip = (id) => {
    const { venues } = this.state;
    const filteredVenues = venues.filter((item) => item._id !== id);
    this.setState({ venues: filteredVenues }, () => this.props.handleVenuesChange(this.state.venues));
  }

  handleDateChange = (date) => {
    this.setState({ date, venues: filterByTime(this.props.venuesByMarket, date) }, () => this.props.handleVenuesChange(this.state.venues));
  }

  render() {
    const { locale, translate, venuesByMarket } = this.props;
    const { radioChoice, area, cluster, venues, date } = this.state;
    return (
      <div className="venues">
        <h2>{translate('statistics.venues')}</h2>
        <RadioButtonGroup
          onChange={this.handleRadioChange}
          name="venuesRadio"
          defaultSelected="allVenues"
          className="radio-button-group"
        >
          <RadioButton
            value="allVenues"
            label={translate('statistics.allVenues')}
          />
          <RadioButton
            value="venues"
            label={translate('statistics.venues')}
          />
          <RadioButton
            value="area"
            label={translate('statistics.area')}
          />
          <RadioButton
            value="cluster"
            label={translate('statistics.cluster')}
          />
          <RadioButton
            value="sameStoreSales"
            label={translate('statistics.sameStoreSales')}
          />
        </RadioButtonGroup>
        {
          radioChoice === 'venues' &&
          <React.Fragment>
            <VenueField
              choices={filterChosenItems(venuesByMarket, venues)}
              handleSelectVenue={this.handleSelectVenue}
              handleSearch={this.handleSearch}
              searchText={this.state.searchVenues}
            />
          </React.Fragment>
        }
        {
          radioChoice === 'area' &&
          <div className="field-wrapper">
            <SelectField
              value={area}
              onChange={this.handleAreaChange}
              floatingLabelText={translate('statistics.selectArea')}
            >
              <MenuItem key="Sydväst" primaryText="Sydväst" value="south" />
              <MenuItem key="Nordöst" primaryText="Nordöst" value="north" />
              <MenuItem key="PN" primaryText="PN" value="central" />
            </SelectField>
          </div>
        }
        {
          radioChoice === 'cluster' &&
          <div className="field-wrapper">
            <SelectField
              value={cluster}
              onChange={this.handleClusterChange}
              floatingLabelText={translate('statistics.selectCluster')}
            >
              <MenuItem key="storstad" primaryText={translate('statistics.city')} value="Storstad" />
              <MenuItem key="kuststad" primaryText={translate('statistics.coastal')} value="Kuststad" />
              <MenuItem key="ort>50k" primaryText={translate('statistics.ort>50k')} value="Ort > 50k" />
              <MenuItem key="ort<50k" primaryText={translate('statistics.ort<50k')} value="Ort < 50k" />
            </SelectField>
          </div>
        }
        {
          radioChoice === 'sameStoreSales' &&
          <DatePicker
            label={translate('statistics.from')}
            onChange={this.handleDateChange}
            inline
            value={date}
          />
        }

        <div className="field-wrapper">
          <ChipRenderer handleRequestDelete={this.handleRemoveChip} values={this.state.venues} translate={translate} source={translate('statistics.venues')} locale={locale} />
        </div>
      </div>
    );
  }
}

export default VenueComponent;
